export const quizTimerHooks = (setTimeSpentOnQuiz: any) => {
  let timer: any;

  const startQuizTimer = () => {
    timer = setInterval(() => {
      setTimeSpentOnQuiz((prev: number) => prev + 1);
    }, 1000);
  };

  const pauseQuizTimer = () => {
    clearInterval(timer);
  };

  return { startQuizTimer, pauseQuizTimer };
};
